import { FunctionComponent, ReactNode } from "react";

import { useCurrentUser } from "../../api";
import { UnauthorizedPage } from "../../pages/UnauthorizedPage";
import { UserPrivilegeType } from "../../types/enums";

import { LoadingContent } from "./LoadingContent";

export interface Props {
    privilegeType: UserPrivilegeType;
    render: ReactNode;
}

export const UserRouteGuard: FunctionComponent<Props> = ({ privilegeType, render }) => {
    const { isLoading, data: user } = useCurrentUser();

    if (import.meta.env.VITE_BYPASS_AUTH === "true" || import.meta.env.VITE_MOCK_ENTIRE_BACKEND === "true") {
        return <>{render}</>;
    }

    if (isLoading) {
        return <LoadingContent />;
    } else if (privilegeType === UserPrivilegeType.Admin && user?.isSystemAdmin) {
        return render;
    } else if (privilegeType === UserPrivilegeType.Internal && (user?.isSystemAdmin || user?.isInternal)) {
        return render;
    } else {
        return <UnauthorizedPage />;
    }
};
